// Admin panel i18n — operations pages:
// AdminCollect (aCl*), AdminSupport (aSp*), AdminSettings (aSet*), AdminLayout (aLay*)
const ops = {
  vi: {
    // AdminCollect
    aClTitle: 'Thu thập nhiệm vụ hot',
    aClSubtitle: 'Lấy video/bài đăng nổi bật kèm liên kết thật, nhập vào kho nhiệm vụ (mặc định tạm dừng để duyệt)',
    aClApiKeyConfigured: 'Đã cấu hình',
    aClApiKeyNotConfigured: 'Chưa cấu hình',
    aClSaving: 'Đang lưu...',
    aClSaveKey: 'Lưu key',
    aClKeySaved: 'Đã lưu API key',
    aClKeyCleared: 'Đã xóa API key',
    aClApiKeyHint: 'Lấy miễn phí tại Google Cloud Console → Credentials → API key (bật YouTube Data API v3). Không có key vẫn dùng được chức năng nhập liên kết.',
    aClNResults: '{n} kết quả',
    aClFetchTrending: 'Lấy trending',
    aClNoTrendingApi: '{platform} không có API trending miễn phí — hãy dán liên kết bài đăng ở ô nhập liên kết bên dưới.',
    aClLinkImport: 'Nhập liên kết',
    aClLinkImportHint: 'YouTube · TikTok · Instagram · Facebook — tối đa 20 mỗi lần',
    aClLinksPlaceholder: 'Dán liên kết, mỗi dòng một link\nhttps://www.tiktok.com/@user/video/123...',
    aClAnalyzeLinks: 'Phân tích liên kết',
    aClPasteLinksFirst: 'Dán liên kết vào ô trước đã',
    aClImportedN: 'Đã nhập {n} nhiệm vụ vào kho (trạng thái tạm dừng)',
    aClSkippedN: ', bỏ qua {n} trùng/Thiếu',
    aClErrors: ' — Lỗi: {list}',
    aClSelectAll: 'Chọn tất cả ({sel}/{total})',
    aClImporting: 'Đang nhập...',
    aClImportN: 'Nhập {n} vào kho',
    aClErrNoKey: "Chưa cấu hình YouTube API key — lưu ở phía trên, hoặc dùng nhập liên kết",
    aClErrTiktok: "TikTok không trả dữ liệu trending — dùng nhập liên kết",
    aClErrNoLinks: "Dán liên kết vào ô trước đã",
    aClErrTooManyLinks: "Tối đa 20 liên kết mỗi lần",
    aClErrTooManyItems: "Tối đa 30 nhiệm vụ mỗi lần",
    aClColTask: 'Nhiệm vụ',
    aClColAction: 'Hành động',
    aClColCategory: 'Danh mục',
    aClColReward: 'Thưởng $',
    aClColQuota: 'Hạn mức/ngày',
    aClActLike: 'Thả tim',
    aClActComment: 'Bình luận',
    aClActSubscribe: 'Đăng ký kênh',
    aClActFollow: 'Theo dõi',
    aClActShare: 'Chia sẻ',
    aClActReview: 'Đánh giá',
    aClActJoin: 'Tham gia nhóm',
    // AdminSupport
    aSpTitle: 'CSKH',
    aSpSubtitle: 'Hỗ trợ khách hàng',
    aSpMessages: 'Tin nhắn ({n})',
    aSpYesterday: 'Hôm qua',
    aSpOnline: 'Online',
    aSpMsgWithdraw: 'Tôi cần hỗ trợ về rút tiền',
    aSpMsgThanks: 'Cảm ơn admin đã hỗ trợ',
    aSpMsgOrderError: 'Đơn hàng của tôi bị lỗi',
    aSpMsgVip: 'Làm sao để nâng cấp VIP?',
    aSpChatHello: 'Xin chào admin',
    aSpChatReply: 'Chào bạn! Tôi có thể giúp gì cho bạn?',
    aSpInputPlaceholder: 'Nhập tin nhắn...',
    aSpEmptyState: 'Chọn một cuộc trò chuyện để bắt đầu',
    // AdminSettings
    aSetTitle: 'Cài đặt',
    aSetSubtitle: 'Cấu hình hệ thống',
    aSetGeneral: 'Cài đặt chung',
    aSetSiteName: 'Tên website',
    aSetSiteUrl: 'URL website',
    aSetPayment: 'Cài đặt thanh toán',
    aSetMinDeposit: 'Số tiền nạp tối thiểu',
    aSetMinWithdraw: 'Số tiền rút tối thiểu',
    aSetWithdrawFee: 'Phí rút tiền (%)',
    aSetChainPay: 'Thanh toán on-chain',
    aSetTronAddress: 'Địa chỉ nhận USDT-TRC20',
    aSetCurrency: 'Đồng tiền',
    aSetChainPayHint: 'Dùng cho đơn may mắn trả bằng USDT-TRC20; lưu là có hiệu lực ngay.',
    aSetInvalidAddress: 'Địa chỉ TRON không hợp lệ',
    aSetSecurity: 'Bảo mật',
    aSetMaintenance: 'Chế độ bảo trì',
    aSetMaintenanceHint: 'Tạm khóa truy cập website',
    aSetNotifications: 'Thông báo',
    aSetEmailNotif: 'Thông báo Email',
    aSetEmailNotifHint: 'Gửi email khi có giao dịch',
    aSetSmsNotif: 'Thông báo SMS',
    aSetSmsNotifHint: 'Gửi SMS khi có giao dịch',
    aSetSave: 'Lưu cài đặt',
    // AdminLayout
    aLayManageUsers: 'Quản lý User',
    aLaySupport: 'CSKH'
  },
  en: {
    // AdminCollect
    aClTitle: 'Trending Task Collection',
    aClSubtitle: 'Fetch featured videos/posts with real links and import them into the task library (imported tasks are paused for review by default)',
    aClApiKeyConfigured: 'Configured',
    aClApiKeyNotConfigured: 'Not configured',
    aClSaving: 'Saving...',
    aClSaveKey: 'Save key',
    aClKeySaved: 'API key saved',
    aClKeyCleared: 'API key removed',
    aClApiKeyHint: 'Get one for free at Google Cloud Console → Credentials → API key (enable YouTube Data API v3). Link import still works without a key.',
    aClNResults: '{n} results',
    aClFetchTrending: 'Fetch trending',
    aClNoTrendingApi: '{platform} has no free trending API — paste post links in the link box below.',
    aClLinkImport: 'Link import',
    aClLinkImportHint: 'YouTube · TikTok · Instagram · Facebook — up to 20 per batch',
    aClLinksPlaceholder: 'Paste links, one per line\nhttps://www.tiktok.com/@user/video/123...',
    aClAnalyzeLinks: 'Analyze links',
    aClPasteLinksFirst: 'Paste links into the input box first',
    aClImportedN: 'Imported {n} tasks into the library (paused)',
    aClSkippedN: ', skipped {n} duplicate/missing',
    aClErrors: ' — Errors: {list}',
    aClSelectAll: 'Select all ({sel}/{total})',
    aClImporting: 'Importing...',
    aClImportN: 'Import {n} into library',
    aClErrNoKey: "YouTube API key not set — save one above, or use link import",
    aClErrTiktok: "TikTok returned no trending data — use link import",
    aClErrNoLinks: "Paste links into the box first",
    aClErrTooManyLinks: "Max 20 links per request",
    aClErrTooManyItems: "Max 30 tasks per import",
    aClColTask: 'Task',
    aClColAction: 'Action',
    aClColCategory: 'Category',
    aClColReward: 'Reward $',
    aClColQuota: 'Daily quota',
    aClActLike: 'Like',
    aClActComment: 'Comment',
    aClActSubscribe: 'Subscribe',
    aClActFollow: 'Follow',
    aClActShare: 'Share',
    aClActReview: 'Review',
    aClActJoin: 'Join group',
    // AdminSupport
    aSpTitle: 'Customer Service',
    aSpSubtitle: 'Customer support',
    aSpMessages: 'Messages ({n})',
    aSpYesterday: 'Yesterday',
    aSpOnline: 'Online',
    aSpMsgWithdraw: 'I need help with withdrawal',
    aSpMsgThanks: 'Thanks to the admin for the support',
    aSpMsgOrderError: 'There is an error with my order',
    aSpMsgVip: 'How do I upgrade to VIP?',
    aSpChatHello: 'Hello admin',
    aSpChatReply: 'Hi! How can I help you?',
    aSpInputPlaceholder: 'Type a message...',
    aSpEmptyState: 'Select a conversation to start',
    // AdminSettings
    aSetTitle: 'Settings',
    aSetSubtitle: 'System configuration',
    aSetGeneral: 'General Settings',
    aSetSiteName: 'Website name',
    aSetSiteUrl: 'Website URL',
    aSetPayment: 'Payment Settings',
    aSetMinDeposit: 'Minimum deposit',
    aSetMinWithdraw: 'Minimum withdrawal',
    aSetWithdrawFee: 'Withdrawal fee (%)',
    aSetChainPay: 'On-chain payment',
    aSetTronAddress: 'USDT-TRC20 receiving address',
    aSetCurrency: 'Currency',
    aSetChainPayHint: 'Used for lucky orders paid in USDT-TRC20; takes effect on save.',
    aSetInvalidAddress: 'Invalid TRON address',
    aSetSecurity: 'Security',
    aSetMaintenance: 'Maintenance mode',
    aSetMaintenanceHint: 'Temporarily lock website access',
    aSetNotifications: 'Notifications',
    aSetEmailNotif: 'Email notifications',
    aSetEmailNotifHint: 'Send email when a transaction occurs',
    aSetSmsNotif: 'SMS notifications',
    aSetSmsNotifHint: 'Send SMS when a transaction occurs',
    aSetSave: 'Save settings',
    // AdminLayout
    aLayManageUsers: 'User Management',
    aLaySupport: 'Customer Service'
  },
  ko: {
    // AdminCollect
    aClTitle: '인기 임무 수집',
    aClSubtitle: '실제 링크가 포함된 인기 동영상/게시물을 가져와 임무 라이브러리로 가져오기 (기본적으로 검토를 위해 일시중지)',
    aClApiKeyConfigured: '설정됨',
    aClApiKeyNotConfigured: '미설정',
    aClSaving: '저장 중...',
    aClSaveKey: '키 저장',
    aClKeySaved: 'API 키가 저장되었습니다',
    aClKeyCleared: 'API 키가 삭제되었습니다',
    aClApiKeyHint: 'Google Cloud Console → 자격 증명 → API 키에서 무료로 발급하세요 (YouTube Data API v3 사용 설정). 키가 없어도 링크 가져오기 기능은 사용할 수 있습니다.',
    aClNResults: '{n}개 결과',
    aClFetchTrending: '인기 콘텐츠 가져오기',
    aClNoTrendingApi: '{platform}에는 무료 인기 API가 없습니다 — 아래 링크 입력창에 게시물 링크를 붙여넣으세요.',
    aClLinkImport: '링크 가져오기',
    aClLinkImportHint: 'YouTube · TikTok · Instagram · Facebook — 회당 최대 20개',
    aClLinksPlaceholder: '링크를 붙여넣으세요. 한 줄에 하나씩\nhttps://www.tiktok.com/@user/video/123...',
    aClAnalyzeLinks: '링크 분석',
    aClPasteLinksFirst: '먼저 입력창에 링크를 붙여넣어 주세요',
    aClImportedN: '{n}개의 임무를 라이브러리로 가져왔습니다(일시중지 상태)',
    aClSkippedN: ', 중복/누락 {n}건 건너뜀',
    aClErrors: ' — 오류: {list}',
    aClSelectAll: '전체 선택 ({sel}/{total})',
    aClImporting: '가져오는 중...',
    aClImportN: '{n}개 가져오기',
    aClErrNoKey: "YouTube API 키가 설정되지 않았습니다 — 위에서 저장하거나 링크 가져오기를 사용하세요",
    aClErrTiktok: "TikTok이 트렌드 데이터를 반환하지 않습니다 — 링크 가져오기를 사용하세요",
    aClErrNoLinks: "먼저 입력칸에 링크를 붙여넣어 주세요",
    aClErrTooManyLinks: "요청당 최대 20개 링크",
    aClErrTooManyItems: "가져오기당 최대 30개 작업",
    aClColTask: '임무',
    aClColAction: '행동',
    aClColCategory: '분류',
    aClColReward: '보상 $',
    aClColQuota: '일일 할당량',
    aClActLike: '좋아요',
    aClActComment: '댓글',
    aClActSubscribe: '채널 구독',
    aClActFollow: '팔로우',
    aClActShare: '공유',
    aClActReview: '리뷰',
    aClActJoin: '그룹 참여',
    // AdminSupport
    aSpTitle: '고객 센터',
    aSpSubtitle: '고객 지원',
    aSpMessages: '메시지 ({n})',
    aSpYesterday: '어제',
    aSpOnline: '온라인',
    aSpMsgWithdraw: '출금 관련 도움이 필요합니다',
    aSpMsgThanks: '관리자분, 도와주셔서 감사합니다',
    aSpMsgOrderError: '주문에 오류가 발생했어요',
    aSpMsgVip: 'VIP로 업그레이드하려면 어떻게 하나요?',
    aSpChatHello: '관리자님 안녕하세요',
    aSpChatReply: '안녕하세요! 무엇을 도와드릴까요?',
    aSpInputPlaceholder: '메시지를 입력하세요...',
    aSpEmptyState: '대화를 선택하여 시작하세요',
    // AdminSettings
    aSetTitle: '설정',
    aSetSubtitle: '시스템 구성',
    aSetGeneral: '일반 설정',
    aSetSiteName: '웹사이트 이름',
    aSetSiteUrl: '웹사이트 URL',
    aSetPayment: '결제 설정',
    aSetMinDeposit: '최소 충전 금액',
    aSetMinWithdraw: '최소 출금 금액',
    aSetWithdrawFee: '출금 수수료 (%)',
    aSetChainPay: '온체인 결제',
    aSetTronAddress: 'USDT-TRC20 수령 주소',
    aSetCurrency: '통화',
    aSetChainPayHint: '행운 주문의 USDT-TRC20 결제에 사용; 저장 즉시 적용됩니다.',
    aSetInvalidAddress: '유효하지 않은 TRON 주소',
    aSetSecurity: '보안',
    aSetMaintenance: '유지보수 모드',
    aSetMaintenanceHint: '웹사이트 접근을 일시 차단',
    aSetNotifications: '알림',
    aSetEmailNotif: '이메일 알림',
    aSetEmailNotifHint: '거래 발생 시 이메일 발송',
    aSetSmsNotif: 'SMS 알림',
    aSetSmsNotifHint: '거래 발생 시 SMS 발송',
    aSetSave: '설정 저장',
    // AdminLayout
    aLayManageUsers: '사용자 관리',
    aLaySupport: '고객 센터'
  },
  ja: {
    // AdminCollect
    aClTitle: '人気タスク収集',
    aClSubtitle: '実リンク付きの人気動画/投稿を取得してタスクライブラリに取り込み（デフォルトは審査のため一時停止）',
    aClApiKeyConfigured: '設定済み',
    aClApiKeyNotConfigured: '未設定',
    aClSaving: '保存中...',
    aClSaveKey: 'キーを保存',
    aClKeySaved: 'APIキーを保存しました',
    aClKeyCleared: 'APIキーを削除しました',
    aClApiKeyHint: 'Google Cloud Console → 認証情報 → APIキーで無料で取得できます（YouTube Data API v3を有効化）。キーがなくてもリンク取り込み機能は利用可能です。',
    aClNResults: '{n}件',
    aClFetchTrending: 'トレンドを取得',
    aClNoTrendingApi: '{platform}には無料のトレンドAPIがありません — 下の入力欄に投稿リンクを貼り付けてください。',
    aClLinkImport: 'リンク取り込み',
    aClLinkImportHint: 'YouTube · TikTok · Instagram · Facebook — 1回最大20件',
    aClLinksPlaceholder: 'リンクを貼り付けてください（1行1リンク）\nhttps://www.tiktok.com/@user/video/123...',
    aClAnalyzeLinks: 'リンクを解析',
    aClPasteLinksFirst: '先に入力欄へリンクを貼り付けてください',
    aClImportedN: '{n}件のタスクをライブラリに取り込みました（一時停止状態）',
    aClSkippedN: '、重複/欠落 {n}件をスキップ',
    aClErrors: ' — エラー: {list}',
    aClSelectAll: 'すべて選択 ({sel}/{total})',
    aClImporting: '取り込み中...',
    aClImportN: '{n}件を取り込み',
    aClErrNoKey: "YouTube APIキーが未設定です — 上で保存するか、リンク取り込みをご利用ください",
    aClErrTiktok: "TikTokがトレンドデータを返しません — リンク取り込みをご利用ください",
    aClErrNoLinks: "まず入力欄にリンクを貼り付けてください",
    aClErrTooManyLinks: "1回につき最大20リンクまで",
    aClErrTooManyItems: "1回につき最大30タスクまで",
    aClColTask: 'タスク',
    aClColAction: 'アクション',
    aClColCategory: 'カテゴリ',
    aClColReward: '報酬 $',
    aClColQuota: '日上限量',
    aClActLike: 'いいね',
    aClActComment: 'コメント',
    aClActSubscribe: 'チャンネル登録',
    aClActFollow: 'フォロー',
    aClActShare: 'シェア',
    aClActReview: 'レビュー',
    aClActJoin: 'グループ参加',
    // AdminSupport
    aSpTitle: 'カスタマーサポート',
    aSpSubtitle: 'お客様サポート',
    aSpMessages: 'メッセージ（{n}）',
    aSpYesterday: '昨日',
    aSpOnline: 'オンライン',
    aSpMsgWithdraw: '出金についてサポートが必要です',
    aSpMsgThanks: '管理者の方、サポートありがとうございます',
    aSpMsgOrderError: '私の注文でエラーが出ています',
    aSpMsgVip: 'VIPへのアップグレードはどうすればいいですか？',
    aSpChatHello: '管理者さん、こんにちは',
    aSpChatReply: 'こんにちは！お手伝いできることはありますか？',
    aSpInputPlaceholder: 'メッセージを入力...',
    aSpEmptyState: '会話を選択して開始してください',
    // AdminSettings
    aSetTitle: '設定',
    aSetSubtitle: 'システム設定',
    aSetGeneral: '一般設定',
    aSetSiteName: 'ウェブサイト名',
    aSetSiteUrl: 'ウェブサイトURL',
    aSetPayment: '決済設定',
    aSetMinDeposit: '最低チャージ額',
    aSetMinWithdraw: '最低出金額',
    aSetWithdrawFee: '出金手数料（%）',
    aSetChainPay: 'オンチェーン決済',
    aSetTronAddress: 'USDT-TRC20 受取アドレス',
    aSetCurrency: '通貨',
    aSetChainPayHint: 'ラッキー注文の USDT-TRC20 決済に使用。保存後すぐ有効。',
    aSetInvalidAddress: 'TRONアドレスが不正です',
    aSetSecurity: 'セキュリティ',
    aSetMaintenance: 'メンテナンスモード',
    aSetMaintenanceHint: 'ウェブサイトへのアクセスを一時的にロック',
    aSetNotifications: '通知',
    aSetEmailNotif: 'メール通知',
    aSetEmailNotifHint: '取引発生時にメールを送信',
    aSetSmsNotif: 'SMS通知',
    aSetSmsNotifHint: '取引発生時にSMSを送信',
    aSetSave: '設定を保存',
    // AdminLayout
    aLayManageUsers: 'ユーザー管理',
    aLaySupport: 'カスタマーサポート'
  },
  zh: {
    // AdminCollect
    aClTitle: '热门任务采集',
    aClSubtitle: '获取带真实链接的热门视频/帖子，导入任务库（默认以暂停状态导入，待审核）',
    aClApiKeyConfigured: '已配置',
    aClApiKeyNotConfigured: '未配置',
    aClSaving: '保存中…',
    aClSaveKey: '保存密钥',
    aClKeySaved: 'API密钥已保存',
    aClKeyCleared: 'API密钥已清除',
    aClApiKeyHint: '可在 Google Cloud Console → 凭据 → API 密钥 免费获取（启用 YouTube Data API v3）。没有密钥也可使用链接导入功能。',
    aClNResults: '{n} 条结果',
    aClFetchTrending: '获取热门',
    aClNoTrendingApi: '{platform}没有免费的热门API——请在下方链接输入框粘贴帖子链接。',
    aClLinkImport: '链接导入',
    aClLinkImportHint: 'YouTube · TikTok · Instagram · Facebook — 每次最多 20 条',
    aClLinksPlaceholder: '粘贴链接，每行一条\nhttps://www.tiktok.com/@user/video/123...',
    aClAnalyzeLinks: '解析链接',
    aClPasteLinksFirst: '请先在输入框中粘贴链接',
    aClImportedN: '已导入 {n} 条任务到任务库（暂停状态）',
    aClSkippedN: '，跳过 {n} 条重复/缺失',
    aClErrors: ' — 错误：{list}',
    aClSelectAll: '全选 ({sel}/{total})',
    aClImporting: '导入中…',
    aClImportN: '导入 {n} 条到任务库',
    aClErrNoKey: "尚未配置 YouTube API Key——请在上方保存，或改用链接导入",
    aClErrTiktok: "TikTok 暂时取不到热门——请改用链接导入",
    aClErrNoLinks: "先在输入框里粘贴链接",
    aClErrTooManyLinks: "每次最多 20 条链接",
    aClErrTooManyItems: "每次最多导入 30 个任务",
    aClColTask: '任务',
    aClColAction: '操作',
    aClColCategory: '分类',
    aClColReward: '奖励 $',
    aClColQuota: '每日限额',
    aClActLike: '点赞',
    aClActComment: '评论',
    aClActSubscribe: '订阅频道',
    aClActFollow: '关注',
    aClActShare: '分享',
    aClActReview: '评价',
    aClActJoin: '加入群组',
    // AdminSupport
    aSpTitle: '客服中心',
    aSpSubtitle: '客户支持',
    aSpMessages: '消息（{n}）',
    aSpYesterday: '昨天',
    aSpOnline: '在线',
    aSpMsgWithdraw: '我需要提现方面的帮助',
    aSpMsgThanks: '感谢管理员的支持',
    aSpMsgOrderError: '我的订单出错了',
    aSpMsgVip: '如何升级VIP？',
    aSpChatHello: '管理员你好',
    aSpChatReply: '您好！请问有什么可以帮您？',
    aSpInputPlaceholder: '输入消息…',
    aSpEmptyState: '选择一个会话开始',
    // AdminSettings
    aSetTitle: '设置',
    aSetSubtitle: '系统配置',
    aSetGeneral: '通用设置',
    aSetSiteName: '网站名称',
    aSetSiteUrl: '网站URL',
    aSetPayment: '支付设置',
    aSetMinDeposit: '最低充值金额',
    aSetMinWithdraw: '最低提现金额',
    aSetWithdrawFee: '提现手续费（%）',
    aSetChainPay: '链上收款',
    aSetTronAddress: 'USDT-TRC20 收款地址',
    aSetCurrency: '币种',
    aSetChainPayHint: '用于幸运订单 USDT-TRC20 链上支付，保存后立即生效。',
    aSetInvalidAddress: 'TRON 地址格式不正确',
    aSetSecurity: '安全',
    aSetMaintenance: '维护模式',
    aSetMaintenanceHint: '暂时锁定网站访问',
    aSetNotifications: '通知',
    aSetEmailNotif: '邮件通知',
    aSetEmailNotifHint: '交易发生时发送邮件',
    aSetSmsNotif: '短信通知',
    aSetSmsNotifHint: '交易发生时发送短信',
    aSetSave: '保存设置',
    // AdminLayout
    aLayManageUsers: '用户管理',
    aLaySupport: '客服中心'
  }
};

export default ops;
